module.exports = __webpack_public_path__ + "site/img/12.6d780737.jpg";